import "./fxoReceivingScreen.js";
import "./fxoReceivingScreenLogic.js";
import "./fxoReceivingScreen.less";
import "./fxoReceivingHomePage.js";
import "./fxoReceivingHomePageLogic.js";



// WEBPACK FOOTER //
// ./src/pages/fxoReceivingScreen/index.js